var API_BASE_URL = '/bff/';
var URL_AUTHENTICATE_PAYMENTS = function URL_AUTHENTICATE_PAYMENTS(jlppr) {
  return "".concat(API_BASE_URL, "v2/orderforms/payments/").concat(jlppr, "/authenticate");
};
var URL_CREATE_PAYMENTS = "".concat(API_BASE_URL, "v2/orderforms/payments");
export { URL_AUTHENTICATE_PAYMENTS, URL_CREATE_PAYMENTS };